import type {ISketchObject} from '../../../../mesh/sketch';
import {SketchRelationKind} from '../relation-compatibility/SketchRelationKinds';
import {MultiTargetRelation} from './MultiTargetRelation';

let count = 0;

/**
 * 判断对象是否为相切关系。
 * @param value 待判断对象。
 * @returns 是否为相切关系。
 */
export function isTangentConstraint(value: object): value is TangentConstraint {
    return Reflect.get(value, 'isTangentConstraint') === true;
}

/**
 * 两条基础曲线的相切关系定义。
 *
 * 目标组合、接触点和公共法线全部由统一参数公式处理；求解确认的内外切符号、
 * 接触点或样条参数通过基类的稳定分支提示参与历史与持久化往返；
 * 本类不选择锚对象、不执行离散投影，也不直接修改任何几何。
 */
export class TangentConstraint extends MultiTargetRelation<ISketchObject> {
    /** 运行时类型标记。 */
    public readonly isTangentConstraint = true;
    /** 关系类型。 */
    public relationType = SketchRelationKind.Tangent;

    public constructor() {
        super();
        this.name = `${this.baseDisplayName}${count}`;
        count += 1;
    }

    /** 基础显示名。 */
    public get baseDisplayName(): string {
        return '相切';
    }
}
